import * as React from 'react';
import { type ModalProps } from '@mui/material';

import {
    StyledWrapper,
    StyledContent,
    StyledModal,
    StyledHeader,
    StyledIcon,
    StyledFooter,
    StyledTitle,
} from '@process-advisor/process-miner/components/modal/modal.styles';
import { Button } from '@process-advisor/process-miner/components/shared/button';

type Props = ModalProps & {
    onClose: () => void,
    onOk?: () => void,
    saveOK?: boolean,
    showCloseIcon?: boolean,
    showButtons?: boolean,
    title?: string,
    width?: string,
    okLabel?: string,
    cancelLabel?: string
}

export const Modal: React.FC<Props> = ({
    children,
    open,
    onClose,
    onOk,
    saveOK = true,
    showCloseIcon = true,
    showButtons = true,
    title,
    width = '90vw',
    okLabel = 'OK',
    cancelLabel = 'Cancel'
}) => {
    const modalRef = React.useRef<HTMLDivElement>(null);

    const handleOnOk = () => {
        onOk();
        onClose();
    };

    return (
        <StyledWrapper open={open} onClose={onClose}>
            <StyledModal onClick={(e) => e.stopPropagation()} ref={modalRef} width={width}>
                <StyledHeader>
                    <StyledTitle>{title}</StyledTitle>
                    {showCloseIcon ? <StyledIcon onClick={onClose} /> : <div />}
                </StyledHeader>
                <StyledContent>
                    {children}
                </StyledContent>
                {
                    showButtons && (
                        <StyledFooter>
                            { onOk && <Button label={okLabel} onClick={handleOnOk} disabled={!saveOK} /> }
                            <Button label={cancelLabel} onClick={onClose} disabled={false} />
                        </StyledFooter>
                    )
                }
            </StyledModal>
        </StyledWrapper>
    );
};
